import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GradingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"grading"}/>
}
